import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';

import { IModalMessages } from '../../../types';

import { styles } from './SetupOnlinePublicationWarning.styles';

export type ISetupOnlinePublicationWarningProps = {
  messages: Pick<
    IModalMessages,
    'navigationMenuIsNotSetup' | 'navigationMenuNotSetupDescription' | 'okayGotIt'
  >;
  onClose(): void;
  open: boolean;
};

export const SetupOnlinePublicationWarning = ({ open, onClose, messages }: ISetupOnlinePublicationWarningProps) => {
  if (!open) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{ sx: styles.dialogPaper, 'data-test': 'dialog--container' }}
      aria-labelledby="dialogTitle"
    >
      <DialogTitle id="dialogTitle" sx={styles.dialogTitle}>
        {messages.navigationMenuIsNotSetup}
        <IconButton
          aria-label="close"
          onClick={onClose}
          size="small"
          sx={styles.closeButton}
          data-test="dialog--close-button"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={styles.dialogContent}>
        <Typography variant="body2" className="dialog-description">
          {messages.navigationMenuNotSetupDescription}
        </Typography>
      </DialogContent>
      <DialogActions sx={styles.dialogActions}>
        <Button variant="contained" color="primary" size="small" onClick={onClose} data-test="cancel-setup-online-publication">
          {messages.okayGotIt}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
